import { SHOPPABLE_PLUGIN } from '~/utils/constants';

export const checkAdimoAvailable = (
  shoppablePlugin?: string,
  adimo?: {
    key?: string;
    url?: string;
    buttonText?: string;
  }
) =>
  (adimo &&
    SHOPPABLE_PLUGIN.ADIMO === shoppablePlugin &&
    Boolean(adimo.key && adimo.url && adimo.buttonText)) ||
  false;
